/**
 * Pull in WP data + load
 * @author Matt Haynes
 * @package Dunfermline
 */

import axios from 'axios';
import MapBox from './Mapbox';
import BrowserHistory from './BrowserHistory';
import UpdateContent from './UpdateContent';
import CheckHashOnLoad from './CheckHashOnLoad';

export default class LoadContent {
    constructor(elem) {
        if (!elem) {
            return;
        }
        this.elem = elem;
        this.tour = elem.dataset.tour;
        this.tourData = null;
        this.pageData = null;
        this.pagePath = window.location.pathname;
        this.pathHash = window.location.hash;
        this.isFirstPageLoad = true;

        this.contentBody = this.elem.querySelector('.tour-content');
        this.buttonBar = this.elem.querySelector('.buttons');
        this.nextTour = this.elem.querySelectorAll('.next-tour');

        this.initData();
    }

    initData() {
        axios
            .all([
                axios.get(`/wp-json/wp/v2/${this.tour}?_embed&per_page=100`),
                axios.get(`/wp-json/wp/v2/pages?slug=${this.pagePath}`),
            ])
            .then(
                axios.spread((tourData, pageData) => {
                    this.tourData = tourData.data;
                    this.pageData = pageData.data;
                    this.tourData.sort((a, b) =>
                        parseInt(a.acf.pin_order, 10) >
                        parseInt(b.acf.pin_order, 10)
                            ? 1
                            : -1
                    );

                    this.currentDisplay = 0;
                    if (this.pathHash !== '') {
                        for (
                            let i = 0, n = this.tourData.length;
                            i < n;
                            i += 1
                        ) {
                            if (`#${this.tourData[i].slug}` === this.pathHash) {
                                this.currentDisplay = i;
                            }
                        }
                    }

                    UpdateContent(
                        this.tourData,
                        this.pageData,
                        this.contentBody,
                        this.currentDisplay,
                        this.isFirstPageLoad
                    );
                })
            )
            .catch((error) => {
                // handle error
                console.log(error);
                this.contentBody.innerHTML =
                    'Sorry, that post does not exist! Please try again later.';
            })
            .finally(() => {
                if (this.tourData.length === 1) {
                    this.nextTour.forEach((elem) => {
                        elem.disabled = true;
                    });
                }

                MapBox(this.tourData, this.pageData[0], this.currentDisplay);
                BrowserHistory(this.tourData, this.pageData, this.contentBody);
                CheckHashOnLoad(this.tourData, this.pageData, this.contentBody);
            });
    }
}
